function getActivities(state) {
    return state.activites;
}

const getActivity = (state) => (activityId) => {
    if (!state.activities || !activityId) {
        return null;
    }

    return state.activities.find(activity => activity.id === activityId);
};

function getAreas(state) {
    return state.areas;
}

const getArea = (state) => (areaId) => {
    if (!state.areas || !areaId) {
        return null;
    }

    return state.areas.find(area => area.id === areaId);
};

function getFacilities(state) {
    return state.facilities;
}

const getFacility = (state) => (facilityId) => {
    if (!state.facilities || !facilityId) {
        return null;
    }

    return state.facilities.find(facility => facility.id === facilityId);
};

const indexOfFacilityUsage = (state) => (facilityUsage) => {
    return state.facilityUsages.findIndex(f => f.index.toString() === facilityUsage.index.toString());
};

const getFacilityUsage = (state) => (index) => {
    if (!state.facilityUsages || !index) {
        return null;
    }

    return state.facilityUsages.find(facilityUsage => facilityUsage.index.toString() === index.toString());
};

function getPermitYears(state) {
    return state.permitYears;
}

const getPermitYear = (state) => (permitYear) => {
    if (!state.permitYears || !permitYear) {
        return null;
    }

    //return state.permitYears.find(y => y === permitYear);
    return state.permitYears === permitYear ? permitYear : null;
};

export default {
    getActivities,
    getActivity,
    getAreas,
    getArea,
    getFacilities,
    getFacility,
    indexOfFacilityUsage,
    getFacilityUsage,
    getPermitYears,
    getPermitYear
};